module.exports = __webpack_public_path__ + "static/media/respond.923950ed.png";